import script from "./ShareSecretView.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareSecretView.vue?vue&type=script&setup=true&lang=js"

import "./ShareSecretView.vue?vue&type=style&index=0&id=6857d585&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6857d585"]])

export default __exports__